import { UTCDate__Add } from "./UTCDate__Add";

export function Session__EndDate(session) {
  return UTCDate__Add(session.startDateTime, session.duration, "minutes");
}
